import { Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { colors, alphaVar } from "../../../ui/colors";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const SparkLineChart = ({ data, title, enableLabel }: { data: any, title: string, enableLabel: boolean }) => {

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        // resizeDelay: 200, // Removed to prevent initial render issues
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                display: enableLabel,
            },
            y: {
                display: enableLabel,
            },
        },
    };

    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // Force a re-render after mount to ensure container dimensions are ready
        // Especially important when rendered inside modals/sidebars with animations
        const timer = setTimeout(() => {
            setIsReady(true);
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const clientData = data?.data;
    let labels = clientData?.labels || clientData?.chartData?.labels;

    let mainData = title === "Worked Hours"
        ? (clientData?.chartData?.values || [])
        : (clientData?.datasets?.[1]?.data || clientData?.datasets?.[0]?.data || []);

    if (title === "Worked Hours" && mainData.length > 0) {
        mainData = mainData.map((val: number) => Number((val / 60).toFixed(1)));
    }

    const Mockdata = {
        labels: labels,
        datasets: [
            title === "Worked Hours" ? {
                label: "Worked Hours",
                data: mainData,
                borderColor: colors.orange[300],
                backgroundColor: alphaVar(colors.orange[300], 0.2),
                fill: true,
            } : {
                label: "Workforce Change",
                data: mainData,
                borderColor: colors.blue[400],
                backgroundColor: alphaVar(colors.blue[400], 0.2),
                fill: true,
            },
        ],
    };

    return (
        <Box sx={{ flex: 1, position: "relative", width: "100%", height: "100%" }}>
            <Line key={isReady ? "ready" : "not-ready"} data={Mockdata} options={options} />
        </Box>
    );
};
